
import common from "../../api/common";
import Group from 'vux/src/components/group/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import value2name from 'vux/src/filters/value2name.js'

export default {
data() {
return {
demo1: false,
demo2: false,
demo3: false,
demoDe1: "",
demoDe2: "",
demoDe3: "",
daiName:"请选择",
commonList:common,
medicineColumns: [{values: [{name: '代煎',price: 10},{name: '不代煎',price: 0.5} ]}],
discountColumns:[{values: [{name: '优惠',price: 10},{name: '无',price: 0.5} ]}],
discount:{name: '优惠',price: 10},
pickDiscount:false,
medicine: {name: '请选择',price: 10},
PickerShow:false,
patientid: this.$store.state.userInfo.id,//患者id
doctorId: this.$store.state.AllOfValue.doctorId =this.$store.state.AllOfValue.doctorId==null?this.$route.query.doctorId:this.$store.state.AllOfValue.doctorId,
orederId: this.$route.query.id,//订单id
orderCode: '',//订单编号
openid: this.$store.state.userInfo.openid,
state: '',
lasttime: '',//倒计时时
hours: '',//倒计时分
minutes: '',//倒计时秒
doctor: {},//医生信息
patient: {},//患者信息
orderinfo: {},//药方订单信息
checked: true,
address: [],//地址列表
addressLen: '',//地址总数
addressId: this.$route.query.addressId,
addressItem:{},
isAddress: false,
isSubmit: true,
befrom: this.$route.query.befrom || '',
showIndex: 999,
resultBuyTime: '',
resultTime: '',

overname: '',
overaddress: '',

isSelect: this.$route.query.isSelect || false,
couponId: this.$route.query.couponId || '',
couponSum: this.$route.query.couponSum || '',
quantity: '',//药方数量ordermedicines
declare: '',//煎药说明
medicinalDetails: [],//药方详情
addressOver: {},//交易关闭状态下默认地址
colortext:'',
goodsType:1,

daijian: "1",//是否代煎
selfMention:{},
selfTime:"",
paystateTime:"",

addressType: this.$route.query.addressType,//是否选择了地址
isDelivery: this.$route.query.isDelivery,
isConfirm: false,
prescription: []
}
},

methods: {
confirmDiscount(picker){
this.discount=picker.currentValue[0];
},
cancelYao(){
this.PickerShow=false;
},

confirmYao(picker){
this.medicine=picker.currentValue.length>0?picker.currentValue[0]:{name:"代煎",price:18};
this.$store.state.medicine = this.medicine;
},
getaddressEdit(){
this.$router.push({path: '/addressedit'});
},

time(servicetime,buytime){
let newtime = servicetime * 60 * 60 * 1000 + buytime;
let oldtime = new Date();
this.lasttime = newtime - oldtime.getTime();
this.hours = parseInt((this.lasttime / (1000 * 60 * 60)));
this.minutes = parseInt((parseFloat(this.lasttime / (1000 * 60 * 60)) - parseInt(this.lasttime / (1000 * 60 * 60))) * 60);
},

onSwipeLeft(i){
this.showIndex = i;
},
onSwiperight(i){
this.showIndex = 999;
},

getAddress(){
let params = {
patientid: this.patientid
};
let that=this;
this.addressList='';
this.$doRequest("/api/patientaddressinfo/getListByKey", params, res=>{
that.address = res;
if(res.length > 0){
this.isAddress = true;
}
});
},

addAddress(index){
if(index==1){
this.$router.push({path: '/address'});
}else{
this.$router.push({path: '/addressedit',query: {orederId: this.orederId,serviceid:'6'}});
}
},

upAddress(item){
this.$router.push({path: '/address',query:{id: item.id,receiver: item.receiver,telephone: item.telephone,province: item.province,city: item.city,county: item.county,address: item.address}});
},

removeAddress(id){
this.$doRequest("/api/patientaddressinfo/delete", [id], res=>{
if(res.res != -1){
this.$toastMsg('收货地址删除成功');
this.showIndex = 999;
this.$router.push({path: '/sx'});
}
});
},

defaultAddress(){
let params = {
patientid: this.patientid,
addressid: this.addressList
}
this.$doRequest("/api/Personal/setDefaultAddress", params, res=>{

});
},


goCoupon(state){
if(state == 1){
this.$store.state.sun.pd = 1;
this.$router.push({path: '/myCoupon',query:{orderId: this.orederId,fromType: 'myOrderDetailsYF',type: this.befrom}});
}
},

getCoupon(){
this.$doRequest("/api/PlacingOrder/getMypreferentialPrice", { parameters: this.patientid }).then(res => {
if(res.result == 0){
let list = [];
res.parameters.forEach(function (item) {
if(item.state == 2 && item.invalidity == 1){
list.push(item);
}
});
if(list != '' ){
this.couponId = list[0].id || '';
this.couponSum = list[0].price || '';
}

}
})
},

getOrderDetails(islook){
if(islook==null){
islook=true;
}
let params = islook?{
/*是否获取医生详情信息 1 获取2 不获取*/
getDoctor: '1',
/*是否获取患者详情信息 1 获取2 不获取*/
getPatient: '1',
/*是否获取主诉  1 获取2 不获取*/
isaction: '1',
/*是否获取此订单的药方订单详细信息 1 获取2 不获取*/
getPrescriptionOrder: '1',
/*药方订单id，如果想获取问诊订单下面的所有药方订单，此处可不传*/
prescriptionOrderId: this.orederId,
}:{
/*是否获取此订单的药方订单详细信息 1 获取2 不获取*/
getPrescriptionOrder: '1',
/*药方订单id，如果想获取问诊订单下面的所有药方订单，此处可不传*/
prescriptionOrderId: this.orederId,
}

this.$doRequest("/api/Inquiry/orderDetails", params, res=>{
if(islook){
this.$store.state.orderAddress = res.orderprescriptioninfos[0].orderid||'';
this.doctor = res.doctor;
this.patient = res.patient;
this.orderinfo = res.orderprescriptioninfos[0];
this.prescription = res.orderprescriptioninfos[0].reOrderprescriptioninfo;
this.demo1 = res.orderprescriptioninfos[0].reOrderprescriptioninfo[0].generationfry==1?false:true;
this.demoDe1 = res.orderprescriptioninfos[0].reOrderprescriptioninfo[0].generationfry==1?false:true;
if(!(res.orderprescriptioninfos[0].reOrderprescriptioninfo[1]==undefined)){
this.demo2 = res.orderprescriptioninfos[0].reOrderprescriptioninfo[1].generationfry==1?false:true;
this.demoDe2 = res.orderprescriptioninfos[0].reOrderprescriptioninfo[1].generationfry==1?false:true;
}
if(!(res.orderprescriptioninfos[0].reOrderprescriptioninfo[2]==undefined)){
this.demo3 = res.orderprescriptioninfos[0].reOrderprescriptioninfo[2].generationfry==1?false:true;
this.demoDe3 = res.orderprescriptioninfos[0].reOrderprescriptioninfo[2].generationfry==1?false:true;
}
if(this.orderinfo.paystate==2 || this.orderinfo.orderstate==4){
this.delivery(2);
}

this.quantity = this.orderinfo.reOrderprescriptioninfo.length;

let _this = this;
_this.medicinalDetails = [];
this.orderinfo.reOrderprescriptioninfo.forEach(function (item) {
_this.medicinalDetails.push(item.medicinename+' '+item.dosage+item.medicineunit);
if(item.decoctionid != null && item.decoctionname != null){
_this.declare += item.medicinename + '('+ item.decoctionname +')     ';
}
});
if (this.orderinfo.paystate == 1 && this.orderinfo.orderstate != 4) {
this.time(this.orderinfo.servicetime,this.orderinfo.buytime);
};
this.orderCode = this.orderinfo.orderid;
this.resultBuyTime = common.timestampToTime(this.orderinfo.buytime,1);
this.resultTime = common.timestampToTime(this.orderinfo.paytime);


if(this.orderinfo.paystate != 1){
let eq = this.orderinfo.address.indexOf('$');
let total = this.orderinfo.address.length;
this.overaddress = this.orderinfo.address.substring(0,eq);
this.overname = this.orderinfo.address.substring(eq+1,total);
}

if(this.orderinfo.paystate == 4){
let eq = this.orderinfo.address.indexOf('$');
let total = this.orderinfo.address.length;
this.overaddress = this.orderinfo.address.substring(0,eq);
this.overname = this.orderinfo.address.substring(eq+1,total);
}

if(this.$store.state.medicine){
this.medicine = this.$store.state.medicine;
}
if(this.isSelect){

this.couponId = this.$route.query.couponId;
this.couponSum = this.$route.query.couponSum;
}else{
if(this.orderinfo.orderstate == 1){
this.getCoupon();
}else if(this.orderinfo.orderstate == 2){
if(this.orderinfo.saletype == 2){
this.couponId = this.orderinfo.couponid;
this.couponSum = this.orderinfo.saleprice;
}
}
}
}
})
},

goConfirm(val){
if(this.isDelivery == 0 || !this.isDelivery){
this.$toastMsg('请选择配送方式');
return;
}else{
if(this.isDelivery == 1 && (!this.addressItem || Object.keys(this.addressItem).length == 0)){
this.isSubmit = true;
this.$toastMsg('请选择收货地址');
return;
}else{





if(this.orderinfo.prescriptionshape == '饮片' && this.orderinfo.generationfry == 3 && (this.medicine.name == '请选择' || this.medicine.name == undefined)){
this.$toastMsg('请选择代煎方式');
return;
}else{
this.isConfirm = val;
}
}
}
},

paySubmit(){
if(this.isSubmit){
this.isSubmit = false;
let _this = this;
if(_this.orderinfo.prescriptionshape=='颗粒'){
_this.daijian="1";
}/*else if(_this.orderinfo.yfgenerationfry==2){
_this.daijian="2";
}*/else if(_this.orderinfo.generationfry!=3){
_this.daijian=_this.orderinfo.generationfry+'';
}else{
_this.daijian=_this.medicine.name=="不代煎"?"1":_this.medicine.name=="代煎"?"2":"";
}
let decoctionren=_this.orderinfo.generationfry==1||_this.orderinfo.generationfry==2?"1":"2";
if(_this.daijian=="1"||_this.daijian=="2"||_this.daijian=="undefined"){
let dj =  this.prescription[0].id + "@" + (this.demo1==true?"2":"1");
let djr = this.prescription[0].id + "@" + (this.demo1==this.demoDe1?"1":"2");

if(!(this.prescription[1]==undefined)){
dj = this.prescription[0].id + "@" + (this.demo1==true?"2":"1") + "," + this.prescription[1].id + "@" + (this.demo2==true?"2":"1");
djr = this.prescription[0].id + "@" + (this.demo1==this.demoDe1?"1":"2") + "," + this.prescription[1].id + "@" + (this.demo2==this.demoDe2?"1":"2");
}else if(!this.prescription[2]==undefined){
dj = this.prescription[0].id + "@" + (this.demo1==true?"2":"1") + "," + this.prescription[1].id + "@" + (this.demo2==true?"2":"1") + "," + this.prescription[2].id + "@" + (this.demo3==true?"2":"1");
djr = this.prescription[0].id + "@" + (this.demo1==this.demoDe1?"1":"2") + "," + this.prescription[1].id + "@" + (this.demo2==this.demoDe2?"1":"2") + "," + this.prescription[2].id + "@" + (this.demo3==this.demoDe3?"1":"2");
}
if(this.orderinfo.paystate==2 || this.orderinfo.orderstate==4){
this.delivery(2);
}

_this.$doRequest("/api/weixinpay/sendWeiPayRequest?ordercode="+ this.orderCode +"&kfc="+ this.couponId +"&addressId="+ this.addressId +"&openid="+this.$store.state.userInfo.patientcode+"&yfdj="+ dj +"&sendtype="+ _this.goodsType +"&decoctionren="+djr,null,res => {
try {
if(res.return_code=="SUCCESS"){

if(res.totalfee*1>0){
WeixinJSBridge.invoke('getBrandWCPayRequest', res.weiAppLetEntity,function(res){
_this.isSubmit = true;
if(res.err_msg=='get_brand_wcpay_request:ok'){
_this.isConfirm = false;

if((_this.befrom && _this.befrom == 'orderList')||(_this.$route.query.ptid!=null&&_this.$route.query.ptid!='')){
_this.$router.push({path: '/sx'});
}else{
_this.getOrderDetails(false);
common.unLock(_this, "todoctorLock" + _this.docid)
_this.$router.push({path: '/physicianVisits?doctorId=' + _this.doctorId});
}
}else{
if(res.err_msg=='get_brand_wcpay_request:fail'){
_this.$toastMsg("支付失败");
}
_this.$router.push({path: '/sx'});
}
});
}else{
_this.isSubmit = true;

if((_this.befrom && _this.befrom == 'orderList')||(_this.$route.query.ptid!=null&&_this.$route.query.ptid!='')){
_this.$router.push({path: '/sx'});
}else{
_this.getOrderDetails(false);
common.unLock(_this, "todoctorLock" + _this.docid)
_this.$router.push({path: '/physicianVisits?doctorId=' + _this.doctorId});
}
}
}else{
_this.isSubmit = true;
_this.$toastMsg(res.return_msg);
}
}catch (e) {
_this.$toastMsg(e);
_this.isSubmit = true;
}
},
err =>{
_this.isSubmit = true;
});
}else{
_this.$toastMsg("请选择代煎");
_this.isSubmit=true;
}

}
},
delivery(index){
if(index == 1){
this.isDelivery = 1;
}else{
this.isDelivery = 2;
this.goodsType=index;
let _this=this;
let dateTime=new Date();
let params={
receiver: '北京好中医潘家园医馆'
}
this.$doRequest("/api/patientaddressinfo/getListByKey",params ,res=>{
let hfmTime=common.timestampToTime(_this.orderinfo.paytime,3);
let dateTime=new Date();
let payTime=common.timestampToTime(dateTime,3);
if(_this.orderinfo.paystate == 2){

if(_this.orderinfo.generationfry=="2"){
_this.paystateTime=hfmTime<"12:00:00"?common.timestampToTime(new Date(),9):common.timestampToTime(dateTime.setDate(dateTime.getDate()+1),9);
}else if(_this.orderinfo.generationfry=="1"){
_this.paystateTime=hfmTime<"15:00:00"?common.timestampToTime(new Date(),9):_this.paystateTime=common.timestampToTime(dateTime.setDate(dateTime.getDate()+1),9);
}
}else if(_this.orderinfo.paystate == 1 && _this.orderinfo.orderstate != 4){

if(_this.orderinfo.generationfry=="2"){
_this.selfTime=payTime<"12:00:00"?common.timestampToTime(new Date(),9): _this.selfTime=common.timestampToTime(dateTime.setDate(dateTime.getDate()+1),9);
}else if(_this.orderinfo.generationfry=="1"){
_this.selfTime=payTime<"15:00:00"?common.timestampToTime(new Date(),9):common.timestampToTime(dateTime.setDate(dateTime.getDate()+1),9);
}else if(_this.medicine.name=="代煎"){
_this.selfTime=payTime<"12:00:00"?common.timestampToTime(new Date(),9):common.timestampToTime(dateTime.setDate(dateTime.getDate()+1),9);
}else{
_this.selfTime=payTime<"15:00:00"?common.timestampToTime(new Date(),9):common.timestampToTime(dateTime.setDate(dateTime.getDate()+1),9);
}
}

_this.selfMention={
"receiver": '北京好中医潘家园医馆',
"telephone": '010—87701199',
"province": '北京市',
"city": '北京市',
"county": '朝阳区',
"address": '潘家园路9号院28号楼底商'
}
})
}
},
init(){
if(this.$store.state.userInfo.telephone == null || this.$store.state.userInfo.telephone == ''){
this.$toastMsg('请完善手机号');
this.$router.push({path: '/boundPhone', query:{form:'myOrderDetailsYF'}});
}
this.patientid = this.$store.state.userInfo.id;
this.addressItem = this.$store.state.addressList;
this.getAddress();
this.getOrderDetails();
}
},

created: function(){
this.orederId = this.$route.query.id;
this.$isLogin(window.location.search.substr(1),this.init);
document.title = '订单详情';
},
components: {
CheckIcon
}
}



// WEBPACK FOOTER //
// ./src/views/myOrderDetailsPZ/index.vue